import { render, staticRenderFns } from "./AddDonationBudget.vue?vue&type=template&id=2c4c383a&scoped=true&"
import script from "./AddDonationBudget.vue?vue&type=script&lang=js&"
export * from "./AddDonationBudget.vue?vue&type=script&lang=js&"
import style0 from "./AddDonationBudget.vue?vue&type=style&index=0&id=2c4c383a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4c383a",
  null
  
)

export default component.exports